import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, 
  Spinner, Badge, Button, Modal, ModalHeader, ModalBody, 
  Form, Label, Input, ModalFooter, UncontrolledTooltip
} from "reactstrap";
import classnames from "classnames";
import { ToastContainer, toast } from "react-toastify";

const BlogList = () => {
  const [activeTab, toggleTab] = useState("1");
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false); // Düzenleme modu kontrolü
  const [isSaving, setIsSaving] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3; // Admin yetki kontrolü

  const [blogData, setBlogData] = useState({
    ID: null,
    Blog_Title: "",
    Blog_Content: "",
    Blog_Image_Url: "",
    Category: "Lojistik",
    Tags: "",
    Is_Active: true,
    Author_ID: authUser?.ID || 0
  });

  const toggleModal = () => {
    setModal(!modal);
    if(modal) {
      setBlogData({ Blog_Title: "", Blog_Content: "", Tags: "", Blog_Image_Url: "", Category: "Lojistik", Is_Active: true });
      setImagePreview(null);
      setSelectedFile(null);
      setIsEdit(false);
    }
  };

  const fetchBlogs = async () => {
    setIsLoading(true);
    try {
      const filter = isAdmin ? "" : "$filter=Is_Active eq true&";
      const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Blogs?${filter}$orderby=Created_DateTime desc`);
      const result = await response.json();
      if (result && result.value) setBlogs(result.value);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchBlogs(); }, [isAdmin]);

  // --- DÜZENLEME MODUNU AÇ ---
  const handleEdit = (blog) => {
    setBlogData({
      ID: blog.ID,
      Blog_Title: blog.Blog_Title,
      Blog_Content: blog.Blog_Content,
      Blog_Image_Url: blog.Blog_Image_Url,
      Category: blog.Category || "Lojistik",
      Tags: blog.Tags || "",
      Is_Active: blog.Is_Active,
      Author_ID: blog.Author_ID
    });
    setImagePreview(blog.Blog_Image_Url);
    setIsEdit(true);
    setModal(true);
  };

  // --- BLOG SİL (DELETE) ---
  const handleDelete = async (id) => {
    if (window.confirm("Bu blog yazısını silmek istediğinize emin misiniz?")) {
      try {
        const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Blogs(${id})`, { method: "DELETE" });
        if (response.ok) {
          toast.success("Yazı başarıyla silindi.");
          fetchBlogs();
        }
      } catch (error) {
        toast.error("Silme işlemi başarısız.");
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // --- KAYDET / GÜNCELLE (POST / PUT) ---
  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      let finalImageUrl = blogData.Blog_Image_Url;

      // Eğer yeni bir dosya seçildiyse önce sunucuya yükle
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const uploadRes = await fetch("https://hiflowapi.stechomeyazilim.info/Uploads/uploads.php", { method: "POST", body: formData });
        const uploadResult = await uploadRes.json();
        if (uploadResult.status) finalImageUrl = uploadResult.url;
      }

      const payload = { ...blogData, Blog_Image_Url: finalImageUrl };
      const url = isEdit ? `https://hiflowapi.stechomeyazilim.info/Blogs(${blogData.ID})` : "https://hiflowapi.stechomeyazilim.info/Blogs";
      const method = isEdit ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        toast.success(isEdit ? "Yazı güncellendi!" : "Yeni yazı eklendi!");
        toggleModal();
        fetchBlogs();
      }
    } catch (error) {
      toast.error("İşlem başarısız.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <React.Fragment>
      <Col >
        <Card className="shadow-sm border-0">
          <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
            <Nav tabs className="nav-tabs-custom border-bottom-0">
              <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{cursor:'pointer'}}>Yazılar</NavLink></NavItem>
            </Nav>
            {isAdmin && <Button color="success" size="sm" onClick={toggleModal}><i className="mdi mdi-plus me-1"></i> Yeni Yazı</Button>}
          </div>

          <TabContent className="p-4" activeTab={activeTab}>
            <TabPane tabId="1">
              {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : 
                blogs.map((blog) => (
                  <div key={blog.ID} className="mb-5 position-relative">
                    <div className="d-flex justify-content-between">
                      <Badge color="soft-primary" pill>{blog.Category}</Badge>
                      {isAdmin && (
                        <div className="d-flex gap-2">
                          <Button color="soft-success" size="sm" onClick={() => handleEdit(blog)} id={`edit-${blog.ID}`}><i className="mdi mdi-pencil font-size-14"></i></Button>
                          <Button color="soft-danger" size="sm" onClick={() => handleDelete(blog.ID)} id={`del-${blog.ID}`}><i className="mdi mdi-delete font-size-14"></i></Button>
                          <UncontrolledTooltip target={`edit-${blog.ID}`}>Düzenle</UncontrolledTooltip>
                          <UncontrolledTooltip target={`del-${blog.ID}`}>Sil</UncontrolledTooltip>
                        </div>
                      )}
                    </div>
                    <h5 className="mt-2"><Link to={`/blog-details/${blog.ID}`} className="text-dark fw-bold">{blog.Blog_Title}</Link></h5>
                    <img src={blog.Blog_Image_Url || "https://placehold.co/800x400"} className="img-thumbnail w-100 my-3" style={{maxHeight:'300px', objectFit:'cover'}} alt="" />
                    <p className="text-muted">{blog.Blog_Content?.substring(0, 150)}...</p>
                    <hr className="my-4" />
                  </div>
                ))
              }
            </TabPane>
          </TabContent>
        </Card>
      </Col>

      {/* --- EKLE / DÜZENLE MODALI --- */}
      <Modal isOpen={modal} toggle={toggleModal} centered size="lg">
        <ModalHeader toggle={toggleModal}>{isEdit ? "Yazıyı Düzenle" : "Yeni Yazı Oluştur"}</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSave}>
            <div className="mb-3"><Label>Başlık</Label><Input required value={blogData.Blog_Title} onChange={e => setBlogData({...blogData, Blog_Title: e.target.value})} /></div>
            <Row>
              <Col md={6} className="mb-3"><Label>Kategori</Label><Input type="select" value={blogData.Category} onChange={e => setBlogData({...blogData, Category: e.target.value})}><option>Lojistik</option><option>Teknoloji</option></Input></Col>
              <Col md={6} className="mb-3"><Label>Görsel (Değiştirmek için seçin)</Label><Input type="file" onChange={handleFileChange} /></Col>
            </Row>
            {imagePreview && <div className="text-center mb-3"><img src={imagePreview} alt="" style={{maxHeight:"150px"}} className="img-thumbnail" /></div>}
            <div className="mb-3"><Label>İçerik</Label><Input type="textarea" rows="6" value={blogData.Blog_Content} onChange={e => setBlogData({...blogData, Blog_Content: e.target.value})} /></div>
            <ModalFooter className="px-0 pb-0 border-0">
              <Button color="primary" type="submit" disabled={isSaving}>{isSaving ? <Spinner size="sm" /> : (isEdit ? "Güncelle" : "Yayınla")}</Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default BlogList;